import styled from 'styled-components';
import Card from 'features/shared/ui/Card';
import { SecondaryButton } from '@gr-monorepo/common/public/ui/Buttons';
import { OlympiadsMain } from '../../OlympiadsListStyled';

export const StatisticMain = styled(OlympiadsMain)`
  gap: 30px;
`;

export const StatisticPageHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  width: 100%;
  min-width: 0;
  margin-bottom: 20px;
`;

export const OlympiadIcon = styled.img`
  flex-shrink: 0;
  width: 56px;
  height: 56px;
  object-fit: contain;
`;

export const BackButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 48px;
  height: 48px;
  padding: 9.6px;
  border: none;
  border-radius: 50%;
  background: #ffffff;
  cursor: pointer;

  svg {
    display: block;
    width: 29px;
    height: 29px;
  }
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 20px;
`;

export const LevelsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 16px;
`;

export const LevelWrapper = styled(Card).attrs({ $padding: 24 })`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const LevelName = styled.div`
  display: flex;
  align-items: center;
  font-size: 18px;
  font-weight: 700;
  line-height: 24px;
`;

export const LevelActionButton = styled(SecondaryButton)`
  > svg,
  > svg path {
    fill: currentColor;
  }
`;

export const StatisticUnavailableCard = styled(Card).attrs({ $padding: 24 })`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  text-align: center;
`;

export const StatisticUnavailableIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--black-20);

  svg {
    display: block;
    width: 56px;
    height: 56px;
  }
`;

export const StatisticUnavailableText = styled.p`
  margin: 0;
  color: var(--black-60);
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
`;

export const ErrorCard = styled.div`
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  max-width: 500px;
  gap: 12px;
  padding: 48px;
  color: var(--font-color);
  text-align: center;
`;

export const ErrorTitle = styled.div`
  margin: 0;
  font-size: 24px;
  font-weight: 700;
  line-height: 30px;
`;

export const ErrorDescription = styled.div`
  margin: 0;
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;

  a {
    color: var(--primary-base);
    text-decoration: underline;
  }
`;

export const StatisticTableCard = styled(Card)`
  width: 100%;
`;

export const StatisticTableLoader = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 240px;
`;

export const StatisticTableMessage = styled.div`
  padding: 40px 16px;
  color: var(--black-60);
  font-size: 16px;
  line-height: 22px;
  text-align: center;
`;